import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from './components/ErrorBoundary';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Properties from './pages/Properties';
import PropertyDetail from './pages/PropertyDetail'
import Nosotros from './pages/Nosotros';
import Contacto from './pages/Contacto';
import WhatsButton from './components/WhatsButton';
import { PerformanceMonitor } from './components/PerformanceMonitor';
import ScrollToTop from './components/ScrollToTop';
import { PerformanceOptimizer } from './utils/performance';

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <PerformanceOptimizer>
          <PerformanceMonitor>
          <Router>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/properties" element={<Properties />} />
              <Route path="/propiedad/:id" element={<PropertyDetail />} />
              <Route path="/nosotros" element={<Nosotros />} />
              <Route path="/contacto" element={<Contacto />} />
              {/* Agrega más rutas según necesites */}
            </Routes>
            <WhatsButton />
          </Router>
        </PerformanceMonitor>
        </PerformanceOptimizer>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;